import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import { JobContext } from '../../../contexts/ContextCreator';

import FGBLabel from '../../Elements/FGBLabel/FGBLabel';
import Button from '../../Input/Button/Button';
import ArrowSVG from '../../SVGs/ArrowSVG/ArrowSVG';
import { JOB_SEARCH_FILTER_TYPES } from '../../Includes/Constants/jobSearch';
import JobSearchFilterListSection from './JobSearchFilterListSection/JobSearchFilterListSection';

import './JobSearchFilter.scss';

const titles = {
    [JOB_SEARCH_FILTER_TYPES.COMPANY]: 'companies',
    [JOB_SEARCH_FILTER_TYPES.LOCATION]: 'locations',
};

export default class JobSearchFilter extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            showMoreCompanies: false,
            showMoreLocations: false,
        };
    }

    isActive = (type, filter) => {
        return this.context.activeFilters[type].includes(filter.value);
    };

    loadSections = (type) => {
        const contentArray = this.context.filters[type];

        if (!contentArray || !contentArray.length) {
            return;
        }

        const DisplayComponents = [];
        const HiddenComponents = [];

        const contents =
            this.props.fixedMode && contentArray
                ? contentArray.filter((content) => this.isActive(type, content))
                : contentArray;

        if (!contents || !contents.length) {
            return;
        }

        const className =
            type === JOB_SEARCH_FILTER_TYPES.REMOTE
                ? 'remote-text'
                : 'text-display';

        contents.forEach((content, idx) => {
            const JobSearchFilterListComponent = (
                <JobSearchFilterListSection
                    key={content.value}
                    active={this.isActive(type, content)}
                    image={content.image}
                    title={content.displayName}
                    count={content.count}
                    value={content.value}
                    className={className}
                    onClick={() => this.context.filterJobs(type, content)}
                />
            );

            return idx <= 4
                ? DisplayComponents.push(JobSearchFilterListComponent)
                : HiddenComponents.push(JobSearchFilterListComponent);
        });

        return (
            <section className="category-section">
                <div className="JobSearchFilter-Title-Section">
                    <div className="title-text">{titles[type]}</div>

                    {contents && contents.length > 5 && (
                        <div
                            className="show-more-trigger"
                            onClick={() => this.toggleMoreContent(type)}
                            role="none"
                        >
                            {this.state[`showMore${type}`] ? 'Less' : 'More'}

                            <ArrowSVG
                                direction={
                                    this.state[`showMore${type}`]
                                        ? 'up'
                                        : 'down'
                                }
                                width="7px"
                                height="10px"
                            />
                        </div>
                    )}
                </div>

                {DisplayComponents}

                {this.state[`showMore${type}`] && HiddenComponents}
            </section>
        );
    };

    toggleMoreContent = (type) => {
        this.setState((previousState) => {
            return {
                [`showMore${type}`]: !previousState[`showMore${type}`],
            };
        });
    };

    render() {
        const clearButtonClass =
            this.props.fixedMode || this.props.modalMode ? 'fixed' : '';

        return (
            <div className="component-Jobs-JobSearchFilter">
                <PageConsumer>
                    {({ pageProps }) => (
                        <React.Fragment>
                            <div className="job-search-filter-title">
                                <FGBLabel className="black-font">
                                    Search Filters
                                </FGBLabel>
                            </div>

                            <div>
                                {pageProps.featureFlags &&
                                    pageProps.featureFlags.remoteJobFilter &&
                                    this.loadSections(
                                        JOB_SEARCH_FILTER_TYPES.REMOTE
                                    )}
                                {this.loadSections(
                                    JOB_SEARCH_FILTER_TYPES.COMPANY
                                )}
                                {this.loadSections(
                                    JOB_SEARCH_FILTER_TYPES.LOCATION
                                )}
                            </div>

                            <div className="filter-btns-div">
                                <div
                                    className={`job-search-filter-clear-button-div ${clearButtonClass}`}
                                >
                                    <Button
                                        type="secondary-blue-gray"
                                        value="Clear"
                                        onClick={this.context.filterJobs}
                                    />
                                </div>

                                {this.props.modalMode && (
                                    <div className="job-search-filter-apply-button-div">
                                        <Button
                                            type="purple-medium-white"
                                            value="Apply"
                                            onClick={this.props.onClick}
                                        />
                                    </div>
                                )}
                            </div>
                        </React.Fragment>
                    )}
                </PageConsumer>
            </div>
        );
    }
}

JobSearchFilter.propTypes = {
    /**
     * fixedMode - mode showing only active filter selections
     */
    fixedMode: PropTypes.bool,
    /**
     * modalMode - mode when this component is rendered inside a modal
     */
    modalMode: PropTypes.bool,
    /**
     * onClick - click handler for modal trigger button
     */
    onClick: PropTypes.func,
};

JobSearchFilter.defaultProps = {
    fixedMode: false,
    modalMode: false,
    onClick: () => {},
};

JobSearchFilter.contextType = JobContext;
